module.exports = __webpack_public_path__ + "static/media/400023_01.c12ced71.png";